import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DelinquentBillService {
  private blockSetting$ = new BehaviorSubject<string>('ALLOW');

  constructor(private http: HttpClient) {
    this.loadBlockInfo();
  }

  private loadBlockInfo(): void {
    this.http.get<any>('/api/status/all').subscribe(
      response => {
        if (response?.blockInfo?.types?.delinquent) {
          this.blockSetting$.next(response.blockInfo.types.delinquent);
        }
      },
      error => console.warn('Failed to load block info:', error)
    );
  }

  public shouldBlockFromSearch(bill: any): boolean {
    return this.blockSetting$.value === 'SEARCH' && bill?.delinquent;
  }

  public shouldBlockPayment(bill: any): boolean {
    const setting = this.blockSetting$.value;
    return bill?.delinquent && (setting === 'PAYMENT' || bill?.paymentBlocks?.includes('Setting - delinquent'));
  }

  public shouldHideBalance(bill: any): boolean {
    return this.blockSetting$.value === 'BALANCE_VIEW' && bill?.delinquent;
  }
}